module.exports = __webpack_public_path__ + "img/stack02.ddda9a04.svg";